export default {"bugsnag":true,"bugsnagReleaseStage":"production","zopim":true,"help_page_url":"https://support.kaizenplatform.net/hc/ja/articles/360000052802","dashboard":"https://app.kaizenplatform.net","api_base":"https://api.kaizenplatform.net","appVersion":"1.0.0","env":"production"}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/config.ts